(function() {
	/**
	 * Renders appointment master (list) page: [Appointment Item]
	 * @param {Object} props - Page context and properties
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.renderAppointmentsPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/appointments.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				appointmentsRaw: null,
				pageContent: null,
				appointments: null,
				categories: [
					{
						codename: 'veranstaltungen_eventi',
						name: 'Veranstaltungen|Eventi'
					}
				],
				queryStringCollection: null,
				queryString: null
			}
		};
		var queryStringDict = WebBaseAprovLV.Utils.parseQuerystring(props.context.querystring);
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page),
			(function() {
				var cache = WebBaseAprovLV.Cache.get('taxonomies.appointment_categories').value;
				if (cache) {
					return $.Deferred().resolve(cache).promise();
				}
				return WebBaseAprovLV.Utils.getTaxonomies({groupname: 'appointment_categories'});
			})()
		)
		.then(function(pageXhr, taxonomiesXhr) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			var taxonomies = Array.isArray(taxonomiesXhr) ? taxonomiesXhr[0] : (taxonomiesXhr || {});
			var limit = WebBaseAprovLV.pagingWindow || 10;
			var now = new Date();
			var filters = {
				categories: (queryStringDict.categories || '').toLowerCase(),
				keywords: queryStringDict.keywords || '',
				month: parseInt((queryStringDict.month || '0').replace(/[^0-9]/g, ''), 10),
				year: parseInt((queryStringDict.year || '0').replace(/[^0-9]/g, ''), 10)
			};
			var categoryQueries = [];
			var categoryQueryString = '';
			var dateQueryString = ['&elements.date_from[gte]=', now.getFullYear(), '-', String('0' + (now.getMonth() + 1)).slice(-2), '-', String('0' + now.getDate()).slice(-2)].join('');
			var keywordsQueryString = '';
			var orderParams = [{
				field: (queryStringDict.order || '').toLowerCase(),
				dir: (queryStringDict.dir || '').toLowerCase(),
				value: ''
			}];
			var orderQueries = [];
			var orderQueryString = '';
			taxonomies.terms && (model.data.categories = taxonomies.terms);
			WebBaseAprovLV.Cache.set('taxonomies.appointment_categories', taxonomies);
			if (pageRaw.items && Array.isArray(pageRaw.items) && pageRaw.items.length) {
				model.data.pageRaw = pageRaw;
				// Category filter:
				if (filters.categories.length) {
					categoryQueries = model.data.categories.filter(function(item) {
						return (new RegExp('(^|,)' + item.codename + '(,|$)', 'i')).test(filters.categories);
					}).map(function(item) {
						return item.codename;
					});
					if (categoryQueries.length) {
						categoryQueryString = '&elements.appointment_categories';
						if (categoryQueries.length === 1) {
							categoryQueryString += '[contains]=' + encodeURIComponent(categoryQueries[0]);
						} else {
							categoryQueryString += '[any]=' + encodeURIComponent(categoryQueries.join(','));
						}
					}
				}
				// Date filter:
				if (filters.year > 0 && filters.month >= 0) {
					dateQueryString = ['&elements.date_from[gte]=', filters.year, '-', String('0' + filters.month).slice(-2), '-01'].join('');
				}
				// Keywords filter:
				if (filters.keywords.replace((/^\s+|\s+$/gm, '').length && filters.keywords.length < 1000)) {
					keywordsQueryString = '&elements.title[in]=' + encodeURIComponent(filters.keywords);
				}
				// Order:
				orderQueries = orderParams.map(function(item) {
					item.dir = /^(asc|desc)?$/i.test(item.dir) ? item.dir : '';
					switch (item.field) {
						case 'last_modified':
							item.dir = item.dir.length ? item.dir : 'desc';
							item.value = ['system.last_modified[', item.dir, ']'].join('');
							break;
						case 'title':
							item.dir = item.dir.length ? item.dir : 'asc';
							item.value = ['elements.title[', item.dir, ']'].join('');
							break;
						default:
							item.dir = item.dir.length ? item.dir : 'asc';
							item.value = ['elements.date_from[', item.dir, ']'].join('');
					}
					return item;
				}).filter(function(item) {
					return item.value.length > 0;
				}).map(function(item) {
					return item.value;
				});
				orderQueryString = orderQueries.length ? '&order=' + orderQueries.join(',') : '';
				return WebBaseAprovLV.Utils.getKKData('?system.type=appointment_item&includeTotalCount=true' + dateQueryString + categoryQueryString + keywordsQueryString + orderQueryString + (queryStringDict.skip ? '&skip=' + queryStringDict.skip : '') + '&limit=' + limit);
			}
			return $.Deferred().reject(model);
		}).then(function(appointmentsRaw) {
			var key;
			var queryParams = [];
			var queryParamsDict = {};
			appointmentsRaw = appointmentsRaw || {};
			model.data.appointmentsRaw = appointmentsRaw;
			if (model.data.pageRaw && model.data.appointmentsRaw) {
				// preserve non paging relevant querystring params
				for (key in queryStringDict) {
					switch (true) {
						case /^(skip|limit)/i.test(key):
							break;
						default:
							queryParams.push([key.toLowerCase(), queryStringDict[key]].join('='));
							queryParamsDict[key.toLowerCase()] = queryStringDict[key];
							break;
					}
				}
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
					appointments: (model.data.appointmentsRaw.items || []).length ? WebBaseAprovLV.Utils.getKKViewModel(model.data.appointmentsRaw) : [],
					queryStringCollection: queryParamsDict,
					queryString: queryParams.join('&')
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).promise();
	};
})();
